// extracted by mini-css-extract-plugin
export default {"root":"App_root__BoKPe","spinner":"App_spinner__ffbEJ","textInactiveAccount":"App_textInactiveAccount__0go9j"};